(() => {
  'use strict';

  const W = 852;
  const H = 1846;
  const root = document.getElementById('devonneBalloonFly');
  if (!root) return;

  const canvas = root.querySelector('#devonneBalloonGame');
  const ctx = canvas.getContext('2d', { alpha: false });
  const loading = root.querySelector('#devonneBalloonLoading');
  const music = root.querySelector('#devonneBalloonMusic');
  const emailForm = root.querySelector('#devonneBalloonEmailForm');
  const emailInput = root.querySelector('#devonneBalloonEmailInput');
  const sendButton = root.querySelector('#devonneBalloonSendButton');
  const formEndpoint = 'https://formspree.io/f/moeqjvwb';
  music.src = root.dataset.music;
  music.preload = 'auto';
  music.loop = true;
  music.volume = 1;
  music.muted = false;
  music.setAttribute('playsinline', '');
  try { music.load(); } catch (_) {}

  ctx.imageSmoothingEnabled = true;

  const assetPaths = {
    player1: root.dataset.player1,
    player2: root.dataset.player2,
    player3: root.dataset.player3,
    titleScreen: root.dataset.titleScreen,
    coverArt: root.dataset.coverArt
  };

  const images = {};
  let assetsReady = false;
  let musicWanted = false;
  let titleActive = true;
  let bestScore = 0;
  let elapsedTime = 0;
  let lastTime = performance.now();
  let dt = 0;

  let currentSprite, playerX, playerY, playerH, playerW, velocityY;
  let gravity, flapPower, maxFallSpeed, maxRiseSpeed;
  let animating, animTimer;
  let reserveBalloons, invincible, invincibleTimer, invincibleDuration, flashTimer;
  let popParticles, letterParticles;
  let started, gameOver, won, score, distance, worldSpeed;
  let safeLaneY, previousSafeLaneY, maxLaneShift, normalSafeHeight, letterSafeHeight, currentSafeHeight;
  let formations, spawnTimer, spawnDelay, backgroundClouds;
  let someStuffLetters, letterStatus, letterMilestones, nextLetterIndex, activeLetter, collectedLetters;
  let rewardUnlocked, completionTimer, completionDuration;
  let emailText, emailActive, emailSubmitted, emailSubmitError;

  const clamp = (v, min, max) => Math.max(min, Math.min(max, v));
  const rand = (min, max) => min + Math.random() * (max - min);
  const randInt = (min, max) => Math.floor(rand(min, max + 1));
  const cy = y => H - y;

  function rgba(r, g, b, a = 255) {
    return `rgba(${r},${g},${b},${a / 255})`;
  }

  function fillRectBL(x, y, w, h, color) {
    ctx.fillStyle = color;
    ctx.fillRect(x, H - y - h, w, h);
  }

  function ellipseCenter(x, y, w, h, color) {
    ctx.save();
    ctx.fillStyle = color;
    ctx.beginPath();
    ctx.ellipse(x, cy(y), w / 2, h / 2, 0, 0, Math.PI * 2);
    ctx.fill();
    ctx.restore();
  }

  function drawLine(x1, y1, x2, y2, width, color) {
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = width;
    ctx.beginPath();
    ctx.moveTo(x1, cy(y1));
    ctx.lineTo(x2, cy(y2));
    ctx.stroke();
    ctx.restore();
  }

  function drawImageCenter(img, x, y, w, h) {
    ctx.drawImage(img, x - w / 2, H - y - h / 2, w, h);
  }

  function drawText(text, x, y, size, color, weight = '400', family = 'Arial, Helvetica, sans-serif') {
    ctx.save();
    ctx.fillStyle = color;
    ctx.font = `${weight} ${size}px ${family}`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(String(text), x, cy(y));
    ctx.restore();
  }

  async function loadImage(name, src) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => { images[name] = img; resolve(); };
      img.onerror = reject;
      img.src = src;
    });
  }

  async function loadAssets() {
    await Promise.all(Object.entries(assetPaths).map(([name, src]) => loadImage(name, src)));
    assetsReady = true;
    loading.style.display = 'none';
    resetGame();
  }

  function resetGame() {
    currentSprite = images.player1;
    playerX = W * 0.18;
    playerY = H * 0.52;
    playerH = H * 0.19;
    playerW = playerH * (1024 / 1536) * 0.94;
    velocityY = 0;

    gravity = -H * 0.34;
    flapPower = H * 0.17;
    maxFallSpeed = -H * 0.22;
    maxRiseSpeed = H * 0.18;

    animating = false;
    animTimer = 0;

    reserveBalloons = 3;
    invincible = false;
    invincibleTimer = 0;
    invincibleDuration = 1.20;
    flashTimer = 0;

    popParticles = [];
    letterParticles = [];

    started = false;
    gameOver = false;
    won = false;
    score = 0;
    distance = 0;
    worldSpeed = W * 0.33;

    safeLaneY = H * 0.52;
    previousSafeLaneY = safeLaneY;
    maxLaneShift = H * 0.10;
    normalSafeHeight = H * 0.33;
    letterSafeHeight = H * 0.42;
    currentSafeHeight = normalSafeHeight;

    formations = [];
    spawnTimer = 0;
    spawnDelay = 1.45;

    backgroundClouds = [];
    for (let i = 0; i < 6; i++) {
      backgroundClouds.push({
        x: randInt(0, W),
        y: randInt(Math.floor(H * 0.12), Math.floor(H * 0.90)),
        scale: randInt(55, 95) / 100,
        speed: W * 0.010
      });
    }

    someStuffLetters = ['S','O','M','E','S','T','U','F','F'];
    letterStatus = [0,0,0,0,0,0,0,0,0];
    letterMilestones = [5,10,16,22,29,36,44,52,60];
    nextLetterIndex = 0;
    activeLetter = null;
    collectedLetters = 0;
    rewardUnlocked = false;
    completionTimer = 0;
    completionDuration = 3.0;

    emailText = '';
    emailActive = false;
    emailSubmitted = false;
    emailSubmitError = false;
    hideEmailForm();
  }

  function updatePlayer() {
    velocityY += gravity * dt;
    if (velocityY < maxFallSpeed) velocityY = maxFallSpeed;
    if (velocityY > maxRiseSpeed) velocityY = maxRiseSpeed;
    playerY += velocityY * dt;

    const hitH = playerH * 0.55;
    if (playerY - hitH / 2 < 0) {
      playerY = hitH / 2;
      takeHit();
    }
    if (playerY + hitH / 2 > H) {
      playerY = H - hitH / 2;
      takeHit();
    }
  }

  function drawPlayer() {
    if (invincible) {
      flashTimer += dt;
      if (Math.floor(flashTimer * 12) % 2 === 1) return;
    }
    drawImageCenter(currentSprite, playerX, playerY, playerW, playerH);
  }

  function updateAnimation() {
    if (animating) {
      animTimer += dt;
      if (animTimer < 0.08) currentSprite = images.player2;
      else if (animTimer < 0.16) currentSprite = images.player3;
      else {
        currentSprite = images.player1;
        animating = false;
        animTimer = 0;
      }
    } else {
      currentSprite = images.player1;
    }
  }

  function updateInvincibility() {
    if (!invincible) return;
    invincibleTimer += dt;
    if (invincibleTimer >= invincibleDuration) {
      invincible = false;
      invincibleTimer = 0;
      flashTimer = 0;
    }
  }

  function takeHit() {
    if (invincible || gameOver) return;
    if (reserveBalloons > 0) {
      reserveBalloons -= 1;
      createPopEffect();
      invincible = true;
      invincibleTimer = 0;
      flashTimer = 0;
      velocityY = H * 0.055;
    } else {
      endGame();
    }
  }

  function updateCourseDifficulty() {
    if (activeLetter) {
      currentSafeHeight = letterSafeHeight;
      maxLaneShift = H * 0.07;
    } else {
      currentSafeHeight = normalSafeHeight;
      maxLaneShift = H * 0.10;
    }
  }

  function updateFormations() {
    spawnTimer += dt;
    if (spawnTimer >= spawnDelay) {
      spawnTimer = 0;
      spawnFlowFormation();
      spawnDelay = activeLetter ? randInt(145, 175) / 100 : randInt(125, 160) / 100;
    }
    for (let i = formations.length - 1; i >= 0; i--) {
      const formation = formations[i];
      formation.x -= worldSpeed * dt;
      if (formation.x < -W * 0.60) formations.splice(i, 1);
    }
  }

  function spawnFlowFormation() {
    previousSafeLaneY = safeLaneY;
    const shift = randInt(Math.floor(-maxLaneShift), Math.floor(maxLaneShift));
    let nextSafeY = safeLaneY + shift;
    const edgeMargin = H * 0.18;
    nextSafeY = clamp(nextSafeY, edgeMargin, H - edgeMargin);

    if (activeLetter) {
      const pull = 0.35;
      nextSafeY = nextSafeY * (1 - pull) + activeLetter.y * pull;
    }
    safeLaneY = nextSafeY;

    const formation = {
      x: W + W * 0.10,
      safeY: safeLaneY,
      safeHeight: currentSafeHeight,
      clouds: []
    };
    const topLimit = safeLaneY + currentSafeHeight / 2;
    const bottomLimit = safeLaneY - currentSafeHeight / 2;
    const pattern = randInt(1, 5);

    if (pattern === 1) {
      addFlowCloud(formation, 0, topLimit + H * 0.09, 0.88);
      addFlowCloud(formation, W * 0.29, bottomLimit - H * 0.09, 0.88);
    } else if (pattern === 2) {
      addFlowCloud(formation, 0, bottomLimit - H * 0.09, 0.88);
      addFlowCloud(formation, W * 0.29, topLimit + H * 0.09, 0.88);
    } else if (pattern === 3) {
      addFlowCloud(formation, 0, topLimit + H * 0.08, 0.84);
      addFlowCloud(formation, W * 0.25, bottomLimit - H * 0.08, 0.84);
      addFlowCloud(formation, W * 0.50, topLimit + H * 0.08, 0.82);
    } else if (pattern === 4) {
      addFlowCloud(formation, 0, bottomLimit - H * 0.08, 0.84);
      addFlowCloud(formation, W * 0.25, topLimit + H * 0.08, 0.84);
      addFlowCloud(formation, W * 0.50, bottomLimit - H * 0.08, 0.82);
    } else {
      addFlowCloud(formation, W * 0.07, topLimit + H * 0.12, 0.80);
      addFlowCloud(formation, W * 0.41, bottomLimit - H * 0.12, 0.80);
    }
    formations.push(formation);
  }

  function addFlowCloud(formation, offsetX, y, scale) {
    const safeBottom = formation.safeY - formation.safeHeight / 2;
    const safeTop = formation.safeY + formation.safeHeight / 2;
    const buffer = H * 0.065 * scale;
    if (y > safeBottom - buffer && y < safeTop + buffer) {
      y = y >= formation.safeY ? safeTop + buffer : safeBottom - buffer;
    }
    y = clamp(y, H * 0.07, H * 0.93);
    formation.clouds.push({ ox: offsetX, oy: y, scale });
  }

  function drawFormations() {
    for (const formation of formations) {
      for (const cloud of formation.clouds) {
        draw16BitCloud(formation.x + cloud.ox, cloud.oy, cloud.scale, false);
      }
    }
  }

  function draw16BitCloud(x, y, scale, background) {
    const p = Math.max(4, Math.floor(Math.min(W, H) * 0.0075 * scale));
    const c1 = background ? rgba(196,224,239,145) : rgba(170,208,231);
    const c2 = background ? rgba(224,240,248,175) : rgba(225,240,249);
    const c3 = background ? rgba(246,251,255,190) : rgba(255,255,255);
    const c4 = background ? rgba(240,248,253,170) : rgba(244,249,253);

    fillRectBL(x - p*7, y - p*2, p*14, p*3, c1);
    fillRectBL(x - p*5, y - p*3, p*10, p*2, c1);
    fillRectBL(x - p*8, y - p, p*16, p*3, c2);
    fillRectBL(x - p*6, y + p*2, p*12, p*3, c2);
    fillRectBL(x - p*7, y, p*14, p*3, c3);
    fillRectBL(x - p*6, y + p*3, p*5, p*3, c3);
    fillRectBL(x - p*5, y + p*6, p*4, p*2, c3);
    fillRectBL(x - p*2, y + p*3, p*7, p*5, c3);
    fillRectBL(x, y + p*8, p*4, p*2, c3);
    fillRectBL(x + p*3, y + p*2, p*4, p*4, c3);
    fillRectBL(x - p*8, y + p, p*2, p*2, c4);
    fillRectBL(x + p*7, y, p*2, p*2, c4);
  }

  function checkCloudCollisions() {
    const playerHitW = playerW * 0.40;
    const playerHitH = playerH * 0.50;
    const px1 = playerX - playerHitW / 2;
    const px2 = playerX + playerHitW / 2;
    const py1 = playerY - playerHitH / 2;
    const py2 = playerY + playerHitH / 2;

    for (const formation of formations) {
      for (const cloud of formation.clouds) {
        const cx = formation.x + cloud.ox;
        const cyv = cloud.oy;
        const p = Math.max(4, Math.floor(Math.min(W, H) * 0.0075 * cloud.scale));
        const cw = p * 10.5;
        const ch = p * 6.0;
        if (px2 > cx - cw/2 && px1 < cx + cw/2 && py2 > cyv - ch/2 && py1 < cyv + ch/2) {
          takeHit();
          return;
        }
      }
    }
  }

  function updateLetters() {
    if (activeLetter) {
      activeLetter.x -= worldSpeed * dt;
      activeLetter.time += dt;
      if (activeLetter.x < -W * 0.08) {
        letterStatus[activeLetter.index] = -1;
        activeLetter = null;
        nextLetterIndex += 1;
      }
      return;
    }
    if (nextLetterIndex >= someStuffLetters.length) return;
    if (score < letterMilestones[nextLetterIndex]) return;
    spawnNextLetter();
  }

  function spawnNextLetter() {
    activeLetter = {
      index: nextLetterIndex,
      char: someStuffLetters[nextLetterIndex],
      x: W + W * 0.12,
      y: safeLaneY,
      time: 0
    };
    activeLetter.y = clamp(
      activeLetter.y + randInt(Math.floor(-H * 0.035), Math.floor(H * 0.035)),
      H * 0.22,
      H * 0.78
    );
  }

  function checkLetterCollision() {
    if (!activeLetter) return;
    const bobY = activeLetter.y + Math.sin(activeLetter.time * 4) * H * 0.006;
    const letterSize = H * 0.060;
    const playerHitW = playerW * 0.72;
    const playerHitH = playerH * 0.78;
    const px1 = playerX - playerHitW / 2;
    const px2 = playerX + playerHitW / 2;
    const py1 = playerY - playerHitH / 2;
    const py2 = playerY + playerHitH / 2;
    const lx1 = activeLetter.x - letterSize * 0.72;
    const lx2 = activeLetter.x + letterSize * 0.72;
    const ly1 = bobY - letterSize * 0.72;
    const ly2 = bobY + letterSize * 0.72;
    if (px2 > lx1 && px1 < lx2 && py2 > ly1 && py1 < ly2) collectActiveLetter();
  }

  function triggerWin() {
    if (won) return;
    rewardUnlocked = true;
    won = true;
    gameOver = false;
    completionTimer = completionDuration;
    activeLetter = null;
  }

  function checkWinState() {
    const allCollected = letterStatus.length === someStuffLetters.length &&
      letterStatus.every(status => status === 1);
    if (collectedLetters >= someStuffLetters.length || allCollected) {
      triggerWin();
    }
  }

  function collectActiveLetter() {
    if (!activeLetter) return;
    const index = activeLetter.index;
    if (letterStatus[index] !== 1) {
      letterStatus[index] = 1;
      collectedLetters = Math.min(someStuffLetters.length, collectedLetters + 1);
    }
    createLetterCollectEffect(activeLetter.x, activeLetter.y, index);
    activeLetter = null;
    nextLetterIndex += 1;
    checkWinState();
  }

  const letterColors = [
    [255,70,80], [255,170,40], [255,225,55], [75,210,100], [55,195,240],
    [70,115,255], [145,75,240], [235,75,210], [255,95,145]
  ];
  const getLetterColor = i => letterColors[i];

  function drawActiveLetter() {
    if (!activeLetter) return;
    const y = activeLetter.y + Math.sin(activeLetter.time * 4) * H * 0.006;
    const size = Math.max(32, H * 0.060);
    const c = getLetterColor(activeLetter.index);
    const dark = rgba(35,45,70);
    const family = 'Arial Black, Arial, sans-serif';
    drawText(activeLetter.char, activeLetter.x - 3, y, size, dark, '900', family);
    drawText(activeLetter.char, activeLetter.x + 3, y, size, dark, '900', family);
    drawText(activeLetter.char, activeLetter.x, y - 3, size, dark, '900', family);
    drawText(activeLetter.char, activeLetter.x, y + 3, size, dark, '900', family);
    drawText(activeLetter.char, activeLetter.x, y, size, rgba(...c), '900', family);
  }

  function createLetterCollectEffect(x, y, index) {
    const c = getLetterColor(index);
    for (let i = 0; i < 16; i++) {
      letterParticles.push({ x, y, vx: randInt(-120,120), vy: randInt(-80,160), life: .55, r:c[0], g:c[1], b:c[2] });
    }
  }

  function updateLetterParticles() {
    for (let i = letterParticles.length - 1; i >= 0; i--) {
      const p = letterParticles[i];
      p.life -= dt;
      p.x += p.vx * dt;
      p.y += p.vy * dt;
      p.vy -= H * 0.18 * dt;
      if (p.life <= 0) letterParticles.splice(i, 1);
    }
  }

  function drawLetterParticles() {
    for (const p of letterParticles) {
      fillRectBL(p.x, p.y, H * 0.006, H * 0.006, rgba(p.r,p.g,p.b,Math.max(0,p.life/.55*255)));
    }
  }

  function createPopEffect() {
    const colors = [[255,70,70],[255,210,40],[60,190,255],[80,220,100],[200,80,255],[255,110,190]];
    for (let i = 0; i < 12; i++) {
      const c = colors[randInt(0, colors.length - 1)];
      popParticles.push({
        x: playerX,
        y: playerY + playerH * 0.18,
        vx: randInt(-90,90),
        vy: randInt(40,150),
        life: .45,
        r:c[0], g:c[1], b:c[2]
      });
    }
  }

  function updatePopParticles() {
    for (let i = popParticles.length - 1; i >= 0; i--) {
      const p = popParticles[i];
      p.life -= dt;
      p.x += p.vx * dt;
      p.y += p.vy * dt;
      p.vy -= H * 0.35 * dt;
      if (p.life <= 0) popParticles.splice(i, 1);
    }
  }

  function drawPopParticles() {
    const size = Math.max(3, H * 0.006);
    for (const p of popParticles) {
      fillRectBL(p.x, p.y, size, size, rgba(p.r,p.g,p.b,Math.max(0,p.life/.45*255)));
    }
  }

  function drawBackgroundClouds() {
    for (const cloud of backgroundClouds) {
      if (started && !gameOver) cloud.x -= cloud.speed * dt;
      if (cloud.x < -150) {
        cloud.x = W + randInt(60, Math.floor(W * 0.35));
        cloud.y = randInt(Math.floor(H * 0.12), Math.floor(H * 0.90));
      }
      draw16BitCloud(cloud.x, cloud.y, cloud.scale, true);
    }
  }

  function drawSky() {
    const strips = 36;
    const h = H / strips;
    for (let i = 0; i < strips; i++) {
      const t = i / (strips - 1);
      const color = rgba(95 + 45*t, 185 + 35*t, 240 + 15*t);
      fillRectBL(0, i*h, W, h + 2, color);
    }
  }

  function drawHealth() {
    const startX = W * 0.055;
    const y = H * 0.93;
    const spacing = Math.max(28, W * 0.045);
    for (let i = 1; i <= 3; i++) drawHudBalloon(startX + (i-1)*spacing, y, i <= reserveBalloons);
  }

  function drawHudBalloon(x, y, alive) {
    const s = Math.max(12, H * 0.018);
    if (!alive) {
      ellipseCenter(x, y, s, s*1.20, rgba(255,255,255,55));
      return;
    }
    ellipseCenter(x, y, s, s*1.20, rgba(255,70,85));
    fillRectBL(x - s*.20, y + s*.18, s*.18, s*.25, rgba(255,220,225));
    fillRectBL(x - s*.10, y - s*.72, s*.20, s*.18, rgba(220,45,60));
    drawLine(x, y - s*.72, x, y - s*1.35, Math.max(1,s*.07), rgba(235,235,235));
  }

  function drawSomeStuffTracker() {
    const totalWidth = W * 0.34;
    const startX = W * 0.50 - totalWidth / 2;
    const spacing = totalWidth / 8;
    const y = H * 0.895;
    const size = Math.max(15, H * 0.021);
    for (let i = 0; i < someStuffLetters.length; i++) {
      let x = startX + i * spacing;
      if (i >= 4) x += W * 0.018;
      let color;
      if (letterStatus[i] === 1) color = rgba(...getLetterColor(i));
      else if (letterStatus[i] === -1) color = rgba(80,100,120,150);
      else color = rgba(255,255,255,100);
      drawText(someStuffLetters[i], x, y, size, color, '400');
    }
  }

  function drawHUD() {
    drawHealth();
    drawText(score, W * 0.50, H * 0.925, Math.max(24,H*.034), rgba(255,255,255));
    drawSomeStuffTracker();

    if (!started) drawText('TAP TO FLY', W*.50, H*.50, Math.max(18,H*.025), rgba(255,255,255));

    if (gameOver) {
      fillRectBL(W*.20, H*.32, W*.60, H*.34, rgba(0,0,0,155));
      drawText('GAME OVER', W*.50, H*.58, Math.max(28,H*.045), rgba(255,255,255), '700');
      drawText(`SCORE  ${score}`, W*.50, H*.50, Math.max(18,H*.027), rgba(255,255,255));
      drawText(`BEST  ${bestScore}`, W*.50, H*.455, Math.max(18,H*.027), rgba(255,255,255));
      if (rewardUnlocked) {
        drawText('REWARD UNLOCKED!', W*.50, H*.405, Math.max(18,H*.027), rgba(255,220,70));
      } else {
        drawText(`${collectedLetters}/9 LETTERS`, W*.50, H*.405, Math.max(18,H*.027), rgba(220,230,240));
      }
      drawText('TAP TO RESTART', W*.50, H*.355, Math.max(18,H*.027), rgba(255,255,255));
    }
  }

  const pixelPatterns = {
    A:['01110','10001','10001','11111','10001','10001','10001'],
    C:['01111','10000','10000','10000','10000','10000','01111'],
    D:['11110','10001','10001','10001','10001','10001','11110'],
    E:['11111','10000','10000','11110','10000','10000','11111'],
    F:['11111','10000','10000','11110','10000','10000','10000'],
    K:['10001','10010','10100','11000','10100','10010','10001'],
    L:['10000','10000','10000','10000','10000','10000','11111'],
    M:['10001','11011','10101','10101','10001','10001','10001'],
    N:['10001','11001','10101','10011','10001','10001','10001'],
    O:['01110','10001','10001','10001','10001','10001','01110'],
    R:['11110','10001','10001','11110','10100','10010','10001'],
    S:['01111','10000','10000','01110','00001','00001','11110'],
    T:['11111','00100','00100','00100','00100','00100','00100'],
    U:['10001','10001','10001','10001','10001','10001','01110'],
    V:['10001','10001','10001','10001','10001','01010','00100']
  };

  function drawPixelText(str, centerX, centerY, size, mainColor) {
    const pixel = Math.max(2, Math.floor(size / 7));
    const charW = pixel * 6;
    const totalW = str.length * charW;
    const startX = centerX - totalW / 2;
    const color = rgba(mainColor[0],mainColor[1],mainColor[2]);
    for (let i = 0; i < str.length; i++) {
      const pattern = pixelPatterns[str[i]];
      if (!pattern) continue;
      for (let row = 0; row < 7; row++) {
        for (let col = 0; col < 5; col++) {
          if (pattern[row][col] === '1') {
            fillRectBL(
              startX + i*charW + col*pixel,
              centerY + (3-row)*pixel,
              pixel,
              pixel,
              color
            );
          }
        }
      }
    }
  }

  function drawWinScreen() {
    drawPixelText('SOME STUFF UNLOCKED!', W*.50, H*.82, Math.max(20,H*.030), [35,45,70]);
    drawPixelText('COVER ART REVEAL', W*.50, H*.75, Math.max(18,H*.027), [255,210,40]);

    const coverH = H * 0.46;
    const coverW = coverH * (3508/4961);
    drawImageCenter(images.coverArt, W*.50, H*.43, coverW, coverH);

    if (!emailActive) {
      const fieldY = H * 0.125;
      fillRectBL(W*.22, fieldY, W*.56, H*.055, rgba(245,245,240));
      let display = 'TYPE EMAIL FOR MORE!';
      if (emailSubmitted) display = 'EMAIL SENT!';
      else if (emailSubmitError) display = 'TRY AGAIN';
      drawText(display, W*.50, fieldY + H*.027, Math.max(14,W*.022), rgba(95,105,115));
    }
  }

  function endGame() {
    gameOver = true;
    if (score > bestScore) bestScore = score;
  }

  function drawTitle() {
    ctx.drawImage(images.titleScreen, 0, 0, W, H);
  }

  function drawFrame() {
    if (!assetsReady) return;
    if (titleActive) {
      drawTitle();
      return;
    }

    drawSky();
    drawBackgroundClouds();

    if (started && !gameOver && !won) {
      updatePlayer();
      updateInvincibility();
      updateLetters();
      updateCourseDifficulty();
      updateFormations();
      distance += worldSpeed * dt;
      score = Math.floor(distance / (W * 0.18));
    }

    drawFormations();
    drawActiveLetter();

    updateAnimation();
    if (won) playerY += H * 1.25 * dt;
    drawPlayer();

    if (started && !gameOver && !won) {
      if (!invincible) checkCloudCollisions();
      checkLetterCollision();
      checkWinState();
    }

    updatePopParticles();
    drawPopParticles();
    updateLetterParticles();
    drawLetterParticles();

    if (won) drawWinScreen();
    else drawHUD();
  }

  function animate(now) {
    dt = Math.min(0.05, Math.max(0, (now - lastTime) / 1000));
    elapsedTime += dt;
    lastTime = now;
    drawFrame();
    requestAnimationFrame(animate);
  }

  function canvasPoint(event) {
    const r = canvas.getBoundingClientRect();
    return {
      x: (event.clientX - r.left) * W / r.width,
      y: H - (event.clientY - r.top) * H / r.height
    };
  }

  function startMusic() {
    musicWanted = true;
    music.muted = false;
    music.volume = 1;
    music.loop = true;

    if (!music.src && root.dataset.music) {
      music.src = root.dataset.music;
    }

    if (music.readyState === 0) {
      try { music.load(); } catch (_) {}
    }

    if (!music.paused) return;

    const playPromise = music.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(error => {
        console.warn('DeVonne Balloon Fly: music play was blocked', error);
      });
    }
  }

  function flap() {
    velocityY += flapPower;
    if (velocityY > maxRiseSpeed) velocityY = maxRiseSpeed;
    animating = true;
    animTimer = 0;
  }

  function showEmailForm() {
    if (emailSubmitted) return;
    emailActive = true;
    emailSubmitError = false;
    emailForm.classList.add('active');
    emailInput.value = emailText;
    requestAnimationFrame(() => {
      emailInput.focus({ preventScroll: true });
      try { emailInput.setSelectionRange(emailInput.value.length, emailInput.value.length); } catch (_) {}
    });
  }

  function hideEmailForm() {
    emailActive = false;
    emailForm.classList.remove('active');
    try { emailInput.blur(); } catch (_) {}
  }

  // iPhone Safari is strict about audio: unlock it on the earliest real touch.
  root.addEventListener('touchstart', () => {
    startMusic();
  }, { passive: true });

  root.addEventListener('click', () => {
    if (!titleActive && music.paused) startMusic();
  }, { passive: true });

  // Prevent Safari's text-selection loupe/blue handles from covering the game.
  root.addEventListener('selectstart', event => {
    if (event.target !== emailInput) event.preventDefault();
  });
  root.addEventListener('contextmenu', event => {
    if (event.target !== emailInput) event.preventDefault();
  });
  root.addEventListener('dragstart', event => {
    if (event.target !== emailInput) event.preventDefault();
  });

  canvas.addEventListener('pointerdown', event => {
    if (!assetsReady) return;
    event.preventDefault();
    startMusic();

    if (titleActive) {
      titleActive = false;
      started = true;
      velocityY = flapPower;
      return;
    }

    if (won) {
      if (emailSubmitted) return;
      const p = canvasPoint(event);
      const fieldX = W * 0.22;
      const fieldY = H * 0.125;
      const fieldW = W * 0.56;
      const fieldH = H * 0.055;
      if (p.x >= fieldX && p.x <= fieldX + fieldW && p.y >= fieldY && p.y <= fieldY + fieldH) showEmailForm();
      return;
    }

    if (gameOver) {
      resetGame();
      return;
    }

    if (!started) started = true;
    flap();
  }, { passive: false });

  emailInput.addEventListener('input', () => {
    emailText = emailInput.value;
  });

  emailForm.addEventListener('submit', async event => {
    event.preventDefault();
    const value = emailInput.value.trim();
    if (!value) return;
    emailText = value;
    sendButton.disabled = true;
    sendButton.textContent = 'SENDING...';
    emailSubmitError = false;

    try {
      const body = new URLSearchParams({ email: value });
      const response = await fetch(formEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept': 'application/json'
        },
        body
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      emailSubmitted = true;
      emailSubmitError = false;
      hideEmailForm();
    } catch (error) {
      console.error(error);
      emailSubmitError = true;
      hideEmailForm();
    } finally {
      sendButton.disabled = false;
      sendButton.textContent = 'SEND';
    }
  });

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      music.pause();
    } else if (musicWanted && !titleActive) {
      startMusic();
    }
  });

  music.addEventListener('error', () => {
    console.error('DeVonne Balloon Fly: music failed to load', music.error);
  });

  loadAssets().catch(err => {
    console.error(err);
    loading.textContent = 'LOAD ERROR — REFRESH';
  });
  requestAnimationFrame(animate);
})();
